"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFormat = void 0;
const errors_1 = require("./errors");
const parse_1 = require("./parse");
/**
 * A utility to enforce a RID matches an expected format. Throws if the provided {@link RID} does not match the provided {@link expectedFormat}.
 * Example:
 * ```
 * assertFormat('sharefile:account-123/packageinstall-456',{
 *   system: 'sharefile',
 *   segments:['account','packageinstall']
 * }); // does not throw
 *
 * assertFormat('sharefile:account-123/packageinstall-456/template-121',{
 *   system: 'sharefile',
 *   segments:['account','packageinstall'],
 *   matchType:'container'
 * }); // does not throw
 *
 * assertFormat('sharefile:account-123/packageinstall-456',{
 *   system:'salesforce',
 *   segments:['publisher','feed','packageinstall']
 * }); // throws
 * ```
 * @param RID The RID string to check a format against
 * @param expectedFormat The format to validate against
 * @throws > {@link FormatAssertionError} if the provided RID does not match, or there is an error parsing the provided RID.
 * @throws > {@link ParseError} when the provided RID string cannot be parsed.
 */
function assertFormat(RID, expectedFormat) {
    try {
        const providedRID = (0, parse_1.parseRID)(RID);
        if (providedRID.system !== expectedFormat.system) {
            throw new errors_1.FormatAssertionError({ message: 'The provided RID does not have a matching `system` part.' });
        }
        if (providedRID.segments.length < expectedFormat.segments.length) {
            throw new errors_1.FormatAssertionError({ message: 'The number of segments on the provided RID and the expected format do not match.' });
        }
        else if (providedRID.segments.length > expectedFormat.segments.length && expectedFormat.matchType !== 'container') {
            throw new errors_1.FormatAssertionError({ message: 'The number of segments on the provided RID exceed that on the expected format. Are you testing if the provided RID is an extension of some format? See assertFormat documentation for how to handle that case.' });
        }
        expectedFormat.segments.map((segmentName, i) => {
            if (segmentName !== providedRID.segments[i].name) {
                throw new errors_1.FormatAssertionError({ message: 'The provided RID differs in one of the segments from the expected format.' });
            }
        });
    }
    catch (error) {
        if (error instanceof errors_1.FormatAssertionError) {
            throw error;
        }
        else {
            throw error;
        }
    }
}
exports.assertFormat = assertFormat;
;
//# sourceMappingURL=assertFormat.js.map